export default {"src":"/_next/static/media/arrowBlack.9fd57ba7.svg","height":9,"width":14,"blurWidth":0,"blurHeight":0};